import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React from "react";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import moment from "moment";
export default function SpecialShiftFormRow({
  item,
  index,
  handleSpecialShiftForm,
  specialShiftValidation,
  disabled,
  promoterOptions,
  removeSpecialShiftForm,
  currentDate,
}) {
  const specialShiftFormRow = React.useMemo(
    () => (
      <Stack key={index} sx={{ my: 2 }} direction={"row"} spacing={2}>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems={"flex-start"}
          sx={{ flex: 7 }}
          spacing={1}
        >
          <DatePicker
            sx={{ flex: 1 }}
            disabled={disabled}
            id="date"
            name="date"
            label="日期"
            minDate={moment(currentDate).startOf("month").format("YYYY-MM-DD")}
            maxDate={moment(currentDate).endOf("month").format("YYYY-MM-DD")}
            value={item.date}
            onChange={(value) => {
              handleSpecialShiftForm(
                index,
                "date",
                moment(value).format("YYYY-MM-DD")
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!specialShiftValidation[index]?.dateErr}
                helperText={specialShiftValidation[index]?.dateErr}
              />
            )}
          ></DatePicker>
          <Autocomplete
            sx={{ flex: 1 }}
            required
            disabled={disabled}
            id="combo-box-demo"
            options={promoterOptions}
            value={item.user}
            onChange={async (e, newValue) => {
              handleSpecialShiftForm(index, "user", newValue);
            }}
            label="員工"
            renderInput={(params) => <TextField {...params} label="員工" />}
          />
          <TextField
            disabled={true}
            value={item.rosterString}
            id="outlined-basic"
            label="更表"
            variant="outlined"
          />
        </Stack>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems={"flex-start"}
          sx={{ flex: 1 }}
        >
          <IconButton
            color="error"
            onClick={() => removeSpecialShiftForm(index)}
          >
            <DeleteForeverIcon></DeleteForeverIcon>
          </IconButton>
        </Stack>
      </Stack>
    ),
    [item, index, removeSpecialShiftForm]
  );
  return specialShiftFormRow;
}
